export const USER_SAFE_INFO = ['organizationOwnerEnabled'];
export const ACCOUNT_SAFE_INFO = ['toggles', 'plan'];

function getSafeObject(obj, safeKeys) {
  try {
    let safeObject = {};
    if (typeof obj === 'object') {
      for (const key in obj) {
        if (safeKeys.includes(key)) {
          safeObject = { ...safeObject, [key]: obj[key] };
        } else {
          const result = getSafeObject(obj[key], safeKeys);
          if (Object.keys(result).length) safeObject = { ...safeObject, [key]: result };
        }
      }
    }
    return safeObject;
  } catch (error) {
    return obj;
  }
}

function saveUserToLocalStorage(payload) {
  let toSave = { ...payload };
  try {
    // TOGGLE_STORAGE_SENSIBLE_INFORMATION_ENABLED
    // TODO: Remove line and if statement below
    const { user } = payload;
    if (user?.toggleStorageSensibleInformationEnabled)
      toSave = getSafeObject(payload, USER_SAFE_INFO);
  } finally {
    localStorage.setItem('user', JSON.stringify(toSave));
  }
}

function saveAccountToLocalStorage(payload) {
  let toSave = { ...payload };
  try {
    // TOGGLE_STORAGE_SENSIBLE_INFORMATION_ENABLED
    // TODO: Remove line and if statement below
    const { toggles } = payload.account;
    if (toggles?.toggleStorageSensibleInformationEnabled)
      toSave = getSafeObject(payload, ACCOUNT_SAFE_INFO);
  } finally {
    localStorage.setItem('account', JSON.stringify(toSave));
  }
}

export { saveUserToLocalStorage, saveAccountToLocalStorage };
